export default "__VITE_ASSET__LOSGprG0__"